if (!customElements.get('brand-enterprise-modal')) {
  customElements.define(
    'brand-enterprise-modal',
    class BrandEnterpriseModal extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.formspree = this.dataset.formspree;
        this.calendly = this.dataset.calendly;
        this.productTitle = this.dataset.productTitle || '';
        this.productUrl = this.dataset.productUrl || '';

        this.openButtons = this.querySelectorAll('[data-enterprise-open]');
        this.openButtons.forEach((button) => {
          button.addEventListener('click', () => this.open());
        });

        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        // Keep dialog above theme chrome / chat widgets.
        document.body.appendChild(this.dialog);

        this.form = this.dialog.querySelector('form');
        this.formView = this.dialog.querySelector('[data-enterprise-form-view]');
        this.successView = this.dialog.querySelector('[data-enterprise-success-view]');
        this.errorEl = this.dialog.querySelector('[data-enterprise-error]');
        this.submitButton = this.dialog.querySelector('[data-enterprise-submit]');

        this.dialog.querySelectorAll('[data-enterprise-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });

        this.form?.addEventListener('submit', (event) => this.onSubmit(event));
      }

      disconnectedCallback() {
        // Dialog lives on body; remove when host is torn down (variant re-render).
        if (this.dialog?.isConnected && this.dialog.parentElement === document.body) {
          this.dialog.close?.();
          this.dialog.remove();
        }
      }

      open() {
        if (!this.dialog) return;
        this.resetViews();
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        const firstField = this.dialog.querySelector('input:not([type="hidden"]):not([tabindex="-1"])');
        firstField?.focus();
      }

      close() {
        if (!this.dialog) return;
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
        }
      }

      resetViews() {
        if (this.formView) this.formView.hidden = false;
        if (this.successView) this.successView.hidden = true;
        if (this.errorEl) {
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
        }
        if (this.submitButton) {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-busy');
        }
      }

      async onSubmit(event) {
        event.preventDefault();
        if (!this.form || !this.formspree) return;

        if (this.errorEl) {
          this.errorEl.hidden = true;
          this.errorEl.textContent = '';
        }

        const formData = new FormData(this.form);
        // Honeypot — bots fill this; humans never see it.
        if (formData.get('_gotcha')) return;

        const payload = {
          name: String(formData.get('name') || '').trim(),
          email: String(formData.get('email') || '').trim(),
          company: String(formData.get('company') || '').trim(),
          message: String(formData.get('message') || '').trim(),
          product: this.productTitle,
          product_url: this.productUrl,
          _subject: `Enterprise inquiry — ${this.productTitle || 'Vuetify Store'}`,
          _replyto: String(formData.get('email') || '').trim(),
        };

        if (this.submitButton) {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('aria-busy', 'true');
        }

        try {
          const response = await fetch(this.formspree, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });

          if (!response.ok) {
            let detail = 'Something went wrong. Please try again.';
            try {
              const data = await response.json();
              if (data?.errors) detail = Object.values(data.errors).flat().join(' ') || detail;
              else if (data?.error) detail = data.error;
            } catch (_) {
              /* ignore */
            }
            throw new Error(detail);
          }

          if (this.formView) this.formView.hidden = true;
          if (this.successView) this.successView.hidden = false;
          this.form.reset();
        } catch (error) {
          if (this.errorEl) {
            this.errorEl.textContent = error?.message || 'Something went wrong. Please try again.';
            this.errorEl.hidden = false;
          }
          if (this.submitButton) {
            this.submitButton.disabled = false;
            this.submitButton.removeAttribute('aria-busy');
          }
        }
      }
    }
  );
}
